import React, { useEffect } from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { communicationHistory } from "../../../services/provider/correspondence"
import { getAppointmentDateFormat, getAppointmentTimeFormat } from "../../../services/provider/common";
import CircularProgress from '@mui/material/CircularProgress';
import { useAxiosLoader } from '../../../plugins/axios'

export default function ShowCommunicationHistory(props) {
    const [loading] = useAxiosLoader();
    const [details] = React.useState(props.details);
    const [communcation, setcommuncation] = React.useState([]);

    useEffect(() => {
        communicationHistory(details.requestId).then(res => {
            setcommuncation(res)
        })
        console.log("details", details)
    }, [details])


    return (
        <div>
            {loading ?
                <div className="m-auto text-center pt-4">
                    <CircularProgress />
                </div> :
                <Timeline position="alternate">
                    {
                        communcation && communcation.length > 0 ? communcation.map((elem, index) => (

                            <TimelineItem key ={index}>
                                <TimelineOppositeContent color="text.secondary">
                                    <div className="text-sm">
                                        {getAppointmentDateFormat(elem.sentTime)} {getAppointmentTimeFormat(elem.sentTime)}
                                    </div>
                                    <div className="pt-1">
                                        <span className="bg-green-100 rounded py-1 px-3 font-semibold text-gray-800 text-lg ">
                                                {elem.status}
                                         </span>
                                    </div>
                                </TimelineOppositeContent>
                                <TimelineSeparator>
                                    <TimelineDot variant="outlined" color={index === 0 ? "success" : 'primary'} />
                                    <TimelineConnector />
                                </TimelineSeparator>
                                <TimelineContent>
                                    <div className={(index % 2 === 1) ? "corr-card-design-2 rounded-lg shadow-lg  px-6 py-4" : "corr-card-design-1 rounded-lg shadow-lg  px-6 py-4"}>
                                        <div className="font-semibold text-md">
                                            {elem.currentStatus} {elem.communicationTypeValue} to {elem.receiver}
                                        </div>
                                        <div>
                                            <div className="font-semibold text-sm py-2">
                                                Subject : {elem.subject}
                                            </div>
                                            <span className="text-sm">
                                                {elem.body}
                                            </span>
                                        </div>
                                    </div>
                                </TimelineContent>
                            </TimelineItem>


                        )) : <div className="text-center font-semibold text-gray-600 pt-2">
                            <span className="bg-red-100 rounded p-2">
                                Communication history is not available
                            </span>
                        </div>
                    }

                </Timeline>
            }
        </div>
    );
}